// Estilos para el componente UserAdmin
const styles = {
  container: {
    p: 3,
    borderRadius: 2
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    mb: 3
  },
  title: {
    fontWeight: 500,
    color: 'primary.main'
  },
  statusAlert: {
    mb: 2
  },
  tableContainer: {
    mt: 2
  },
  tableHeader: {
    bgcolor: '#f5f5f5'
  },
  userRow: {
    '&:hover': {
      bgcolor: '#f9f9f9'
    }
  },
  roleSelect: {
    minWidth: 120
  },
  projectChip: {
    m: 0.5
  },
  projectSelect: {
    minWidth: 200,
    mr: 1
  },
  actionButton: {
    ml: 1
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    p: 3
  }
};

export default styles;